import type { ButtonHTMLAttributes, CSSProperties, ReactNode } from "react";

interface PillProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  active?: boolean;
  color?: string;
  activeBackground?: string;
  variant?: "toggle" | "tag";
  children: ReactNode;
}

export function Pill({
  active = false,
  color,
  activeBackground,
  variant = "toggle",
  className = "",
  style,
  children,
  type = "button",
  ...props
}: PillProps) {
  const shouldApplyColor = Boolean(color && (active || variant === "tag"));
  const colorStyle: CSSProperties | undefined = shouldApplyColor
    ? { color, borderColor: color, ...(activeBackground && active ? { background: activeBackground } : {}) }
    : undefined;

  return (
    <button
      type={type}
      className={`mmm-pill mmm-pill--${variant} ${active ? "is-active" : ""} ${className}`.trim()}
      style={{ ...colorStyle, ...style }}
      aria-pressed={props["aria-pressed"] ?? (active ? true : undefined)}
      {...props}
    >
      {children}
    </button>
  );
}
